import React, { useState, useEffect } from "react";
import { functions } from "../firebase/firebase"; 
import { httpsCallable } from "firebase/functions";

const StockCashFlowValuationTable = ({ stockId }) => {
    
  const [projectedCashFlow, setProjectedCashFlow] = useState([]);
  const [valuation, setValuation] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStockDetails = async () => {
   const updateValueFn = httpsCallable(functions, "updateValue");
      try {
         const response = await updateValueFn({ id: stockId });

        setProjectedCashFlow(response.data.projectedCashFlow || []);
        setValuation(response.data.valuation || []);
      } catch (err) {
        setError(err.message);
        console.error("Error occurred:", err);
      }
    };

    fetchStockDetails();
  }, [stockId]);

  // Limit to 5 years
  const displayedCashFlow = projectedCashFlow.slice(0, 5);
  const displayedValuation = valuation.slice(0, 5);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto bg-white border border-gray-300 ">
        <thead>
          <tr className="bg-gray-200">
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs ">
              {" "}
            </th>
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs">
              Mar-24
            </th>
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs">
              Mar-25
            </th>
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs">
              Mar-26
            </th>
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs">
              Mar-27
            </th>
            <th className="px-4 py-2 text-right border border-gray-300 bg-gray-100 text-xs">
              Mar-28
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white">
            <td className="px-4 py-2 text-left border border-gray-300 text-xs">
              Projected Cash Flow (Cr):
            </td>
            {displayedCashFlow.length > 0 ? (
              displayedCashFlow.map((value, index) => (
                <td
                  key={index}
                  className="px-4 py-2  border border-gray-300 text-xs text-right"
                >
                  {value.toFixed(2)}
                </td>
              ))
            ) : (
              <td
                colSpan={5}
                className="px-4 py-2  border border-gray-300 text-xs text-right"
              >
                N/A
              </td>
            )}
          </tr>
          <tr className="bg-gray-100 text-xs">
            <td className="px-4 py-2  text-left border border-gray-300 text-xs">
              Valuation (Cr):
            </td>
            {displayedValuation.length > 0 ? (
              displayedValuation.map((value, index) => (
                <td
                  key={index}
                  className="px-4 py-2 text-right border border-gray-300"
                >
                  {value.toFixed(2)}
                </td>
              ))
            ) : (
              <td
                colSpan={5}
                className="px-4 py-2 text-right border border-gray-300"
              >
                N/A
              </td>
            )}
          </tr>
          {error && (
            <tr>
              <td
                colSpan="6"
                className="px-4 py-2 text-red-500 text-right border border-gray-300"
              >
                Error: {error}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StockCashFlowValuationTable;
